import React from 'react';

import LogoNevidis from './LogoNevidis';
import LogoNortia from './LogoNortia';
import LogoCompactNevidis from './LogoCompactNevidis';

const theme = {
  current: 'nevidis',
  logo: {
    current: 'nevidis',
    list: {
      nevidis: {
        name: 'nevidis',
        label: 'Nevidis',
        component: <LogoNevidis />,
        default: true
      },
      nevidisCompact: {
        name: 'nevidisCompact',
        label: 'Nevidis',
        component: <LogoCompactNevidis />,
        default: true
      },
      nortia: {
        name: 'nortia',
        label: 'Nortia',
        component: <LogoNortia />,
        default: true
      }
    }
  },
  login: {
    list: {
      nevidis: {
        title: 'Identification',
        subTitle: "Accès à l'espace apporteur",
        pageTitle: 'Identification Nevidis',
      },
      nortia: {
        title: 'Identification',
        subTitle: "Accès à l'espace apporteur",
        pageTitle: 'Identification Nortia',
      }
    }
  }
};

export default theme;
